import { render, staticRenderFns } from "./SearchBarFormattedItems.vue?vue&type=template&id=900539aa&"
import script from "./SearchBarFormattedItems.vue?vue&type=script&lang=js&"
export * from "./SearchBarFormattedItems.vue?vue&type=script&lang=js&"
import style0 from "./SearchBarFormattedItems.vue?vue&type=style&index=0&id=900539aa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports